import {isDonationTicketDefinition, isFreeTicketDefinition, isTicketed} from '@wix/wix-events-commons-statics'
import {State} from '../types/state'
import {getReservations} from './checkout'
import {getEvent} from './event'
import {getInvoice} from './placed-order'
import {getTickets} from './tickets'

export const isCouponsAccepted = (state: State) => state.checkoutOptions.options.acceptCoupons

export const isGiftCardsAccepted = (state: State) => state.checkoutOptions.options.acceptGiftCards

export const isUpgradeNeededForCheckout = (state: State) => {
  const {
    grandTotal: {amount},
  } = getInvoice(state)

  return !state.checkoutOptions.options.premiumServices && Number(amount) > 0
}

export const isFixedPriceTicketReserved = (state: State) => {
  const event = getEvent(state)
  const reservations = getReservations(state)
  const tickets = getTickets(state)

  return (
    isTicketed(event) &&
    reservations.some(({ticket: {id}}) => {
      const ticketDefinition = tickets.find(ticket => ticket.id === id)

      return !isFreeTicketDefinition(ticketDefinition) && !isDonationTicketDefinition(ticketDefinition)
    })
  )
}

export const isCouponInputVisible = (state: State) => isFixedPriceTicketReserved(state) && isCouponsAccepted(state)

export const isGiftCardInputVisible = (state: State) => isFixedPriceTicketReserved(state) && isGiftCardsAccepted(state)
